// ── Shared constants for the metrics feature ─────────────────────────────────

export const ORG_PALETTE = ['#006eb8', '#29a383', '#6e56cf', '#ab6400']

export const CLIENT_PALETTES = [
  ['#5b8ff9', '#0d74ce', '#3d8fd1', '#1a5a8a', '#7ab3e0'],
  ['#208368', '#4db89a', '#2da882', '#156b55', '#68c4a8'],
  ['#9e86e8', '#7c5fc4', '#b8a4f0', '#6244b0', '#c9bbf7'],
  ['#d4a017', '#b88a00', '#e8c44a', '#8a6500', '#f0d882'],
]

export const STAGE_COLORS: Record<string, string> = {
  draft:                '#6e56cf',
  qc_review:            '#006eb8',
  layout_review:        '#29a383',
  editorial_approval:   '#d97706',
  publish_ready:        '#ab6400',
  published:            '#1a7f37',
  recalled:             '#c0392b',
  blocked:              '#e17b47',
}

export const STAGE_ORDER = [
  'draft', 'qc_review', 'layout_review', 'editorial_approval', 'publish_ready', 'published', 'recalled', 'blocked',
]

// Ordered stages for the Pipeline Intelligence stacked bar (inner-to-outer)
export const PIPELINE_STAGE_ORDER = [
  'qc_review', 'layout_review', 'editorial_approval', 'blocked',
]

export const PIPELINE_STAGE_COLORS: Record<string, string> = {
  qc_review:          '#006eb8',
  layout_review:      '#29a383',
  editorial_approval: '#d97706',
  blocked:            '#c0392b',
}

export const CHART_COLOR = '#006eb8'

export const CHART_COLORS = [
  '#006eb8', '#5b8ff9', '#29a383', '#ab6400', '#6e56cf', '#ce2c31', '#0d74ce', '#208368',
]
